<script>
    import PageLandingElectricite from "../PageLandingElectricite";

    export default {
        name: 'PageLandingElectriciteGerantPME',
        extends: PageLandingElectricite,
        data() {
            return {
                form_background_filename: 'visuel-fond-questionnaire-gerant-pme.jpg',
            };
        }
    }
</script>
